const border = "1px solid #666";
const backgroundColor = "var(--pv-table-header-bg)";
const fontSize = "14px";
const pt = 1.5;

export const fullHeadBorder = {
  muiTableHeadCellProps: {
    align: "center",
    sx: {
      border,
      backgroundColor,
      fontSize,
      pt,
    },
  },
};
export const rightBorder = {
  muiTableHeadCellProps: {
    sx: {
      borderRight: border,
      backgroundColor,
      borderLeft: "1px solid var(--pv-table-border)",
    },
  },
  muiTableBodyCellProps: {
    sx: {
      borderRight: border,
      borderLeft: "1px solid var(--pv-table-border)",
    },
  },
};

export const leftBorder = {
  muiTableHeadCellProps: {
    sx: {
      borderLeft: border,
      backgroundColor,
      borderRight: "1px solid var(--pv-table-border)",
    },
  },
  muiTableBodyCellProps: {
    sx: {
      borderLeft: border,
      borderRight: "1px solid var(--pv-table-border)",
    },
  },
};
